import { WarehouseDiscount } from 'entities/Warehouse';
import { FIRST_MONTH_DISCOUNT_REGEX } from 'shared/utils/regex';

export const getBoxDiscountedPriceAmount = ({
  warehouseDiscounts,
  boxPrice,
  boxSquare,
}: {
  warehouseDiscounts: Nullable<WarehouseDiscount[]> | undefined;
  boxPrice: Nullable<number> | undefined;
  boxSquare?: number;
}): Nullable<number> => {
  if (!warehouseDiscounts || !boxPrice) {
    return null;
  }

  const sortedDiscounts = [...warehouseDiscounts].sort((a, b) => a.priority - b.priority);

  const firstMonthDiscounts = sortedDiscounts.filter((discount) =>
    discount.discounts.split(',').some((d) => FIRST_MONTH_DISCOUNT_REGEX.test(d.trim())),
  );

  let actualDiscount: WarehouseDiscount | undefined = firstMonthDiscounts.find((discount) => !discount.unitSizes) || firstMonthDiscounts[0];

  if (boxSquare) {
    actualDiscount = firstMonthDiscounts.find((discount) => {
      const unitSizes = discount.unitSizes?.split(',').map((size) => Number(size));

      return unitSizes?.includes(boxSquare);
    });
  }

  const firstMonthDiscountValue = actualDiscount?.discounts.split(',')[0].split('-')[1];

  const isPercentageDiscount = firstMonthDiscountValue?.includes('%');

  if (firstMonthDiscountValue) {
    const discountValue = isPercentageDiscount
      ? Number(firstMonthDiscountValue.slice(0, firstMonthDiscountValue.indexOf('%')))
      : Number(firstMonthDiscountValue);

    return isPercentageDiscount ? boxPrice - (boxPrice * discountValue) / 100 : discountValue;
  }

  return null;
};
